import { render, staticRenderFns } from "./myProgramPacksPage.vue?vue&type=template&id=1afcdb04&"
import script from "./myProgramPacksPage.vue?vue&type=script&lang=ts&"
export * from "./myProgramPacksPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports